import { useState, useEffect } from 'react';
import Modal from '../../../components/Modal';
import Icon from '../../../components/Icon';
import canUseDOM from '../../../utilities/canUseDOM';

export default function AddToAny() {
  const [showModal, setShowModal] = useState(false);

  function handleModalClose() {
    setShowModal(false);
  }

  function handleModalOpen() {
    setShowModal(true);
  }

  useEffect(() => {
    if (canUseDOM()) {
      const { location, document } = window;
      const pageTitle = document.title;
      const pageUrl = location.href;

      const script = document.createElement('script');
      script.src = 'https://static.addtoany.com/menu/page.js';
      script.async = true;

      var a2a_config: any = a2a_config || {};
      a2a_config.linkname = `${pageTitle}`;
      a2a_config.linkurl = `${pageUrl}`;
      a2a_config.onclick = 1;
      a2a_config.num_services = 6;
      // for drop down menu only
      // a2a_config.custom_services = [
      //   'instagram',
      //   'https://www.instagram.com/add?A2A_LINKURL_ENC&title=A2A_LINKNAME_ENC',
      // ];

      document.body.appendChild(script);

      const modalHeader = document.querySelector('.modal-header');
      const hasAddToAnyServices = a2a_config.num_services > 0;
      if (hasAddToAnyServices && modalHeader) {
        modalHeader?.classList.add('bb-0');
      }
    }
  });

  return (
    <div className="product-details__share">
      <div className="product-details__share-link">
        <button className="btn btn-link" onClick={handleModalOpen}>
          <span className="d-inline-block pr-2">
            <Icon iconName="share-new" modifierCss="icon--share" />{' '}
          </span>
          Share
        </button>
      </div>

      <Modal
        title="Share"
        isVisible={showModal}
        handleClose={handleModalClose}
        escapeToClose={true}
      >
        <button
          onClick={handleModalClose}
          className="btn btn-close"
          aria-label="Close"
        >
          <Icon iconName="close-thin" />
        </button>
        <div className="a2a_kit a2a_kit_size_64 a2a_default_style share-icons">
          <div className="share-icons-wrapper">
            <a className="a2a_button_facebook share-icon">
              <span className="a2a_label">Share on Facebook</span>
              Facebook
            </a>
            <a className="a2a_button_pinterest share-icon">
              <span className="a2a_label">Share on Pinterest</span>
              Pinterest
            </a>
          </div>
          <div className="share-icons-wrapper">
            <a className="a2a_button_twitter share-icon">
              <span className="a2a_label">Share on Twitter</span>
              Twitter
            </a>
            <a className="a2a_button_email share-icon">
              <span className="a2a_label">Share by Email</span>
              Email
            </a>
          </div>
          <div className="share-icons-wrapper">
            <a className="a2a_button_linkedin share-icon">
              <span className="a2a_label">Share on LinkedIn</span>
              LinkedIn
            </a>
            <a className="a2a_button_whatsapp share-icon">
              <span className="a2a_label">Share on WhatsApp</span>
              WhatsApp
            </a>
          </div>
        </div>
      </Modal>
    </div>
  );
}
